<template>
  <div class="modal"
       id="modal-update-subtest"
       tabindex="-1"
       role="dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            Edit Subtest #{{ subtest.id }}
          </h5>
        </div>

        <div class="modal-body">
          <form role="form">
            <div class="form-group row">
              <label class="col-md-4 col-form-label text-md-right">Test Type</label>

              <div class="col-md-6">
                <multiselect v-model="testType"
                             id="test-type"
                             name="test_type"
                             :class="{'is-invalid': updateSubtestForm.errors.has('test_type')}"
                             deselect-label="Required"
                             select-label="Select"
                             placeholder="Choose a test type"
                             open-direction="bottom"
                             label="title"
                             track-by="id"
                             :options="testTypes"
                             :searchable="true"
                             :allow-empty="false"
                             @select="fillTestVariations">
                </multiselect>
                <span class="invalid-feedback" v-if="updateSubtestForm.errors.has('test_type')">
                    <strong>{{ updateSubtestForm.errors.get('test_type') }}</strong>
                </span>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-md-4 col-form-label text-md-right">Subtest Type</label>

              <div class="col-md-6">
                <multiselect v-model="subtestType"
                             id="subtest-type"
                             name="subtest_type"
                             :class="{'is-invalid': updateSubtestForm.errors.has('subtest_type')}"
                             deselect-label="Required"
                             select-label="Select"
                             placeholder="Choose a subtest type"
                             open-direction="bottom"
                             label="title_en"
                             track-by="id"
                             :options="subtestTypes"
                             :searchable="true"
                             :allow-empty="false">
                </multiselect>
                <span class="invalid-feedback" v-if="updateSubtestForm.errors.has('subtest_type')">
                    <strong>{{ updateSubtestForm.errors.get('subtest_type') }}</strong>
                </span>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-md-4 col-form-label text-md-right">Test Variation</label>

              <div class="col-md-6">
                <multiselect v-model="testVariation"
                             id="test-variation"
                             name="test_variation"
                             :class="{'is-invalid': updateSubtestForm.errors.has('test_variation')}"
                             deselect-label="Required"
                             select-label="Select"
                             placeholder="Choose a test variation"
                             open-direction="bottom"
                             label="title_en"
                             track-by="id"
                             :options="testVariations"
                             :searchable="true"
                             :allow-empty="false">
                </multiselect>
                <span class="invalid-feedback" v-if="updateSubtestForm.errors.has('test_variation')">
                    <strong>{{ updateSubtestForm.errors.get('test_variation') }}</strong>
                </span>
              </div>
            </div>

            <div class="form-group row">
              <label for="vws_id" class="col-md-4 col-form-label text-md-right">VWS ID</label>

              <div class="col-md-6">
                <input id="vws_id"
                       type="text"
                       class="form-control"
                       name="vws_id"
                       v-model="updateSubtestForm.vws_id"
                       :class="{'is-invalid': updateSubtestForm.errors.has('vws_id')}"
                       required autofocus>

                <span class="invalid-feedback"
                      role="alert"
                      v-if="updateSubtestForm.errors.has('vws_id')">
                    <strong>{{ updateSubtestForm.errors.get('vws_id') }}</strong>
                </span>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-md-4 text-md-right col-form-label">
                <label class="form-check-label form-check-toggle text-md-right">
                  <input class="form-check-input"
                         v-model="updateSubtestForm.grading_by_subtest_type"
                         type="checkbox"
                         name="grading_by_subtest_type" /><span></span>
                </label>
              </div>
              <div class="col-md-6">
                <label class="text-md-left">Grading by subtest type</label>
              </div>
              <span class="invalid-feedback"
                    role="alert"
                    v-if="updateSubtestForm.errors.has('grading_by_subtest_type')">
                  <strong>{{ updateSubtestForm.errors.get('grading_by_subtest_type') }}</strong>
              </span>
            </div>

            <div class="form-group row">
              <div class="col-md-4 text-md-right col-form-label">
                <label class="form-check-label form-check-toggle text-md-right">
                  <input class="form-check-input"
                         v-model="updateSubtestForm.active"
                         type="checkbox"
                         name="active" /><span></span>
                </label>
              </div>
              <div class="col-md-6">
                <label class="text-md-left">Active</label>
              </div>
              <span class="invalid-feedback"
                    role="alert"
                    v-if="updateSubtestForm.errors.has('active')">
                  <strong>{{ updateSubtestForm.errors.get('active') }}</strong>
              </span>
            </div>
          </form>
        </div>

        <div class="modal-footer">
          <button type="button"
                  class="btn btn-default"
                  data-dismiss="modal">
            Close
          </button>
          <button type="button"
                  class="btn btn-primary"
                  @click.prevent="updateSubtest"
                  :disabled="updateSubtestForm.busy">
            Update
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';

export default {
  props: ['subtest', 'subtestTypes', 'testTypes'],

  components: {
    Multiselect
  },

  /**
   * The component's data.
   */
  data () {
    return {
      updateSubtestForm: new AppForm({
        subtest_type: null,
        test_type: null,
        test_variation: null,
        vws_id: null,
        grading_by_subtest_type: false,
        active: false,
      }),

      testVariations: [],

      subtestType: null,
      testType: null,
      testVariation: null,
    };
  },

  watch: {
    subtest: function (newSubtest, oldSubtest) {
      this.initData(newSubtest);
    }
  },

  mounted () {
    this.initData(this.subtest);
  },

  methods: {
    fillTestVariations (selectedTestType) {
      this.testVariation = null;

      this.testVariations = this.testTypes
        .find(testType => testType.id === selectedTestType.id)
        .test_variations;
    },

    initData (subtest) {
      this.updateSubtestForm.subtest_type = subtest.subtest_type_id;
      this.updateSubtestForm.test_type = subtest.test_type_id;
      this.updateSubtestForm.test_variation = subtest.test_variation_id;
      this.updateSubtestForm.vws_id = subtest.vws_id;
      this.updateSubtestForm.active = subtest.active;
      this.updateSubtestForm.grading_by_subtest_type = subtest.grading_by_subtest_type;

      this.subtestType = this.subtestTypes.find(subtestType => subtestType.id === subtest.subtest_type_id);
      this.testType = this.testTypes.find(testType => testType.id === subtest.test_type_id);
      this.testVariations = this.testType.test_variations;
      this.testVariation = this.testVariations.find(testVariation => testVariation.id === subtest.test_variation_id);
    },

    updateSubtest () {
      let self = this;

      if (this.subtestType) {
        this.updateSubtestForm.subtest_type = this.subtestType.id;
      }

      if (this.testType) {
        this.updateSubtestForm.test_type = this.testType.id;
      }

      if (this.testVariation) {
        this.updateSubtestForm.test_variation = this.testVariation.id;
      }

      App.put('/api/subtests/' + this.subtest.id, this.updateSubtestForm)
        .then(() => {
          $('#modal-update-subtest').modal('hide');

          self.$parent.$emit('getSubtest', self.subtest.id);
          self.$parent.$emit('updateSubtests');
        });
    },
  }
};
</script>
